import { ReactNode, useRef } from 'react';
import * as Styled from './style';

interface TextInputProps {
  icon?: ReactNode;
  placeholder: string;
  value: string;
	onChange: (value: string) => void;
}

export function TextInput({ icon, placeholder, value, onChange } : TextInputProps ) {

  const inputRef = useRef<HTMLInputElement>(null);

	return (
    <Styled.InputWrapper
      onClick={() => {
          if (inputRef.current) inputRef.current.focus();
      }}
    >
      { icon && icon }
      <input
        ref={inputRef}
        placeholder={placeholder}
        className="textInput"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </Styled.InputWrapper>
  )
}